export class Croquis {
    id: number;
    etage_id: number;
    nom: string;
    data: string;
    path: string;
    hauteur_plafond: number;
    fiche_intervention_id: number;
    dossier_intervention_id: number;
    nom_niveau: string;

    public constructor(init?: Partial<Croquis>) {
      Object.assign(this, init);
    }
  }
